export const getToolySlatePastedContent = (htmlPaste: string) => {
  if(htmlPaste && htmlPaste.includes("TOOLY-FRAGMENT")) {
    try {
      const fragmentMatch = htmlPaste.match(/TOOLY-FRAGMENT:(.*?)-->/);
      if(fragmentMatch) {
        const parsedNodes = JSON.parse(fragmentMatch[1]);
        return parsedNodes;
      }
    } catch(e) {
    }
  }
}

export const createToolySlateClipboard = (data: any) => {;
  return `<!-- TOOLY-FRAGMENT:${JSON.stringify(data)} -->`;
}

export const writeToolySlateClipboardContent = (data: any, textFallback: string) => {

  const clipboardItem = new ClipboardItem({
    'text/html': new Blob([createToolySlateClipboard(data)], { type: 'text/html' }),
    'text/plain': new Blob([textFallback], { type: 'text/plain' }),
  });

  navigator.clipboard.write([clipboardItem]).catch(err => {
    console.error('Failed to copy:', err);
  });
}
